import { allWordsCapitalize } from '@cocoonspace/shared/utils/capitalize'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Trans } from 'next-i18next'

import type { TimeSlot } from '../../templates/booking-stepper'
import { TextTimeSelect } from './text-time-select'

export interface FooterDateTimeProps {
	value: TimeSlot
	onChange: (value: TimeSlot) => void
}

export const FooterDateTime = ({ value, onChange }: FooterDateTimeProps) => {
	return (
		<Trans
			parent='div'
			className='flex flex-row items-center gap-x-1'
			i18nKey={'booking:stepper.priceFooter.dateStartFrom'}
			values={{
				day: allWordsCapitalize(
					dateTimeUtils(value.day).customFormat('dateLong'),
				),
			}}
			components={{
				StartInput: (
					<TextTimeSelect
						value={value}
						type='start'
						onChange={(start) => onChange({ ...value, start })}
					/>
				),
				EndInput: (
					<TextTimeSelect
						value={value}
						type='end'
						onChange={(end) => onChange({ ...value, end })}
					/>
				),
			}}
		/>
	)
}
